import type { HTMLAttributes } from 'react'

import { cn } from '@/utils/cn'

type CardProps = HTMLAttributes<HTMLDivElement> & {
  padded?: boolean
}

export function Card({ padded = true, className, ...props }: CardProps) {
  return <div className={cn('pc-card', padded && 'p-4 sm:p-5', className)} {...props} />
}

export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn('font-semibold text-fg', className)} {...props} />
}
